import React from 'react';

import WebsiteAdminFetchingSettingNumericFieldRow, {
	WebsiteAdminFetchingSettingNumericFieldRowUnit,
} from '~/components/app/WebsiteAdminFetchingSettingNumericFieldRow';



type Props = {
	name: string,
};

const WebsiteAdminFetchingSettingDomSizeLimitFieldRow: React.FC<Props> = (props) => {
	const {
		name,
	} = props;

	return (
		<WebsiteAdminFetchingSettingNumericFieldRow
			autoValue={2097152}
			label="DOM size limit"
			name={name}
			unit={WebsiteAdminFetchingSettingNumericFieldRowUnit.Byte}
		/>
	);
};



export default WebsiteAdminFetchingSettingDomSizeLimitFieldRow;
